import LandingPageSetupDetails from "./LandingPageSetupDetails";

export default LandingPageSetupDetails;